import React, { useEffect } from 'react';
import { Spinner, SpinnerSize } from '@amzn/stencil-react-components/spinner';
import {usePrincipal, saveCookies } from '../../hooks';
import { useGetContactInfoQuery } from '../../services/invite';
import WelcomeContentView from './WelcomeContentView';
import Footer from './Footer';
import ContactHelpErrorBoundary from './ContactHelpErrorBoundary';
import '../.././styles/alumni.scss';
import { recordEvent } from 'src/analytics/amplify';

export default function WelcomeScreen() {
    saveCookies();
    const [principal] = usePrincipal();
    const { isLoading } = useGetContactInfoQuery(principal);

    useEffect(() => {
        recordEvent({
            name: 'WelcomeScreen.Render',
        });
    }, []);

    return (
        <ContactHelpErrorBoundary>
            <div className="fullscreen">
                <div className="flex-container">
                    <div data-testid="welcomeImage" className="flex-box-left-image">
                    </div>
                    <div className="flex-box-right">
                        <div data-testid="welcomeContent" className="content-wrap">
                            { isLoading ? <Spinner data-testid="welcomeSpinner" size={SpinnerSize.Medium} /> :
                                <WelcomeContentView />
                            }
                        </div>
                        <div data-testid="footer" className="footer-container">
                            <Footer/>
                        </div>
                    </div>
                </div>
            </div>
        </ContactHelpErrorBoundary>
    );
}
